<template>
    <div class="redeem-content" v-loading="loading" element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
        <div class="page-background">
            <div class="page-background--shadow"></div>
            <img class="page-background--image" src="../../assets/images/bg-default.jpg" />
        </div>
        <!-- 标题 -->
        <img class="title" src="@/assets/images/redeem-title.png">
        <div class="ticket-content">
            <el-form ref="form" :model="form" :rules="rules">
                <el-form-item style="width: 100%;" label="Store(門店)" prop="storeId">
                    <el-select style="width: 100%;" v-model="form.storeId" placeholder="Please select a store"
                        filterable>
                        <el-option v-for="dict in storeOptions" :key="dict.id" :label="dict.name" :value="dict.id" />
                    </el-select>
                </el-form-item>
                <el-form-item style="width: 100%;" label="Platform(平臺)" prop="sysType">
                    <el-select style="width: 100%;" v-model="form.sysType" placeholder="Please choose a platform"
                        filterable>
                        <el-option v-for="dict in sysTypeOptions" :key="dict.value" :label="dict.label"
                            :value="dict.value" />
                    </el-select>
                </el-form-item>
                <el-form-item style="width: 100%;" label="Code(券碼)" prop="code">
                    <el-input v-model="form.code"
                        placeholder="Please enter the coupon code of Meituan/Dianping/Tiktok and other platforms"
                        clearable @input="changeCodeContent"></el-input>
                </el-form-item>
            </el-form>
        </div>
        <!-- 门票信息 -->
        <div class="ticket-display" v-if="ticketInfoByCode.id">
            <img v-if="ticketInfoByCode.image" class="ticket-image" :src="ticketInfoByCode.image">
            <div class="ticket-right">
                <div class="ticket-top">
                    <!-- 标题 -->
                    <div class="title">{{ ticketInfoByCode.english_name }}</div>
                    <div class="title">{{ ticketInfoByCode.name || ticketInfoByCode.title_type }}</div>
                </div>
                <!-- 添加门票数量 -->
                <div class="ticket-detail">
                    <div class="money" v-if="ticketInfoByCode.money">￥{{ ticketInfoByCode.money }}</div>
                </div>
            </div>
        </div>
        <div class="dialog-footer">
            <el-button type="primary" plain @click="goBack">
                <div class="cn">返回</div>
                <div class="en">Return</div>
            </el-button>
            <el-button type="primary" v-if="!ticketInfoByCode.id" @click="getTicketDetailsByCodeFun">
                <div class="cn">査詢</div>
                <div class="en">Query</div>
            </el-button>
            <el-button type="primary" v-else @click="redeemTicketClick">
                <div class="cn">兌換</div>
                <div class="en">Exchange</div>
            </el-button>
        </div>
    </div>
</template>
<script>
import { storeList } from "@/api/activity";
import { getTicketDetailsByCode, makeTicketByCode } from "@/api/index";
export default {
    data() {
        return {
            // 表单参数
            form: {},
            storeOptions: [],//门店列表
            // 表单校验
            rules: {
                storeId: [{ required: true, message: "Please select a store", trigger: "change" }],
                sysType: [{ required: true, message: "Please choose a platform", trigger: "change" }],
                code: [{ required: true, message: "Please enter the coupon code of Meituan/Dianping/Tiktok and other platforms", trigger: "blur" }],
            },
            sysTypeOptions: [
                { label: '抖音', value: '1' },
                { label: '美團', value: '2' },
                { label: '口碑', value: '3' },
                { label: '手動門票/自助機出票', value: '4' },
            ],//平台列表
            ticketInfoByCode: {},//券码查询的门票信息
            loading: false, // 加载状态
        }
    },
    mounted() {
        this.getStoreList()
        this.reset()
    },
    methods: {
        // 返回
        goBack() {
            this.$router.back()
        },
        // 表单重置
        reset() {
            this.form = {
                storeId: undefined,
                sysType: undefined,
                code: undefined,
            };
        },
        // 获取门店列表
        getStoreList() {
            this.loading = true
            storeList()
                .then((res) => {
                    if (res.data.code == 200) {
                        this.storeOptions = res.data.data
                    } else {
                        if (res.data.code == 405) {
                            this.$message({
                                message: '帳號過期請重新登入',
                                type: 'error'
                            });
                            localStorage.removeItem('satoken')
                            this.$router.replace('/')
                        } else {
                            this.$message({
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    }
                })
                .finally(() => {
                    this.loading = false
                })
        },
        // 获取门票信息
        getTicketDetailsByCodeFun() {
            this.$refs["form"].validate(valid => {
                if (valid) {
                    this.loading = true
                    getTicketDetailsByCode(this.form)
                        .then((res) => {
                            if (res.data.code == 200) {
                                this.ticketInfoByCode = res.data.data
                                if (!res.data.data) {
                                    this.$message({
                                        message: '請核對券碼是否輸入正確',
                                        type: 'error'
                                    });
                                } else {
                                    this.$message({
                                        message: '査詢成功',
                                        type: 'success'
                                    });
                                }
                            } else {
                                if (res.data.code == 405) {
                                    this.$message({
                                        message: '帳號過期請重新登入',
                                        type: 'error'
                                    });
                                    localStorage.removeItem('satoken')
                                    this.$router.replace('/')
                                } else {
                                    this.$message({
                                        message: res.data.message,
                                        type: 'error'
                                    });
                                }
                            }
                        }).finally(() => {
                            this.loading = false
                        })
                }
            })
        },
        // 门票兑换
        redeemTicketClick() {
            this.$refs["form"].validate(valid => {
                if (valid) {
                    let name = this.ticketInfoByCode.name || this.ticketInfoByCode.title_type
                    this.$confirm('是否確認兌換名稱為"' + name + '"的門票?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.loading = true
                        makeTicketByCode(this.form)
                            .then((res) => {
                                if (res.data.code == 200) {
                                    // this.$message({
                                    //     message: '兌換成功，快去進行場次預約吧~',
                                    //     type: 'success'
                                    // });
                                    // 跳转到我的门票页面，发起提醒弹窗
                                    this.$router.push({
                                        path: '/myTicket',
                                        query: {
                                            status: 'redeem',
                                        }
                                    });
                                } else {
                                    if (res.data.code == 405) {
                                        this.$message({
                                            message: '帳號過期請重新登入',
                                            type: 'error'
                                        });
                                        localStorage.removeItem('satoken')
                                        this.$router.replace('/')
                                    } else {
                                        this.$message({
                                            message: res.data.message,
                                            type: 'error'
                                        });
                                    }
                                }
                            }).finally(() => {
                                this.loading = false
                            })
                    })

                }
            })
        },
        // 监听券码的值
        changeCodeContent() {
            this.ticketInfoByCode = {}
        },
    },
}
</script>
<style lang="less">
.redeem-content {
    .el-button--primary {
        background-color: #fff;
        border-color: #fff;
        color: #000;
    }

    .el-button--primary.is-plain {
        background-color: #000;
        border-color: #fff;
        color: #fff;
    }

    .el-button--primary:hover,
    .el-button--primary:focus {
        background-color: #fff;
        border-color: #fff;
        color: rgba(0, 0, 0, .8);
    }

    .el-button--primary.is-plain:hover,
    .el-button--primary.is-plain:focus {
        background-color: #000;
        border-color: rgba(255, 255, 255, .8);
        color: rgba(255, 255, 255, .8);
    }

    .el-form-item__label {
        color: #fff !important;
    }

    .page-background {
        position: fixed;
        right: 0;
        top: 0;
        bottom: 0;
        left: calc(50% + 20px);

        .page-background--shadow {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            background: linear-gradient(to right, rgb(0, 0, 0) 0%, rgba(0, 0, 0, 0) 20%);
            z-index: 1;
        }

        .page-background--image {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            right: 0;
            object-fit: cover;
        }
    }

    width: 100%;
    min-height: 100vh;
    background-color: #000;
    padding:20px 50px 50px;
    box-sizing: border-box;
    color: #fff;
    padding-bottom: 100px;
    box-sizing: border-box;


    .dialog-footer {
        width: calc(40% + 10px);
        position: fixed;
        left: 0;
        bottom: 0;
        padding: 20px 0 20px 50px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        background-color: #000;
        z-index: 100;

        .el-button {
            width: 45%;
        }
    }



    .title {
        width: 40%;
        height: auto;
    }

    .ticket-content {
        width: 40%;
        min-width: 300px;
    }

    .ticket-display {
        width: 40%;
        margin: 10px 0;
        min-width: 300px;
        border: 1px solid #fff;
        padding: 10px;
        box-sizing: border-box;
        display: flex;

        .ticket-image {
            width: 140px;
            height: 100%;
            object-fit: fill;
            border-radius: 5px;
        }

        .ticket-right {
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            font-size: 10px;
            padding: 10px;
            box-sizing: border-box;

            .title {
                width: 100%;
                font-size: 15px;
            }

            .ticket-detail {
                display: flex;
                align-items: center;
                justify-content: space-between;

                .money {
                    font-size: 20px;
                    font-weight: bold;
                }
            }

        }
    }
}

/* 响应式设计：在屏幕宽度小于 480px 时调整字体和布局 */
@media (max-width: 780px) {
    .redeem-content {
        padding: 20px;
        padding-bottom: 100px;

        .page-background {
            display: none;
        }

        .title {
            width: 100% !important;
        }

        .ticket-content {
            width: 100% !important;
        }


        .dialog-footer {
            width: 100%;
            padding: 20px;
            min-width: 300px;
        }

        .ticket-display {
            width: 100%;
        }

        .ticket-display .image {
            width: 100px !important;
        }
    }

    .el-message-box {
        width: 300px !important;
    }

}
</style>